import { trace } from 'rytm-helpers'
import Controller from './Controller'
import 'owl.carousel';


class OwlCarouselController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initCarousel()
    setTimeout(() => {
      this.onWindowResize()
    }, 200)
  }
  addEventListeners() {
    super.addEventListeners()
    $(window).on('resize', $.proxy(this.onWindowResize, this));
  }
  removeEventListeners() {
    super.removeEventListeners()
    $(window).off('resize', $.proxy(this.onWindowResize, this));
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e)
    this.destroyCarousel()
  }

  /**
   * OWN
   */
  onWindowResize(e) {
    clearTimeout(this.windowResizeTimeout)
    this.windowResizeTimeout = setTimeout(() => {
      this.refreshCarousel()
    }, 500)
  }
  refreshCarousel() {
    this.destroyCarousel()
    this.initCarousel()
  }
  getCarouselParamsResponsive(el) {
    switch (el.dataset.items) {
      case "2":
        return {
          0: {
            items: 1,
          },
          340: {
            items: 2,
          },
          576: {
            items: 2,
          },
          768: {
            items: 2,
          },
          992: {
            items: 2,
          },
          1200: {
            items: 2,
          },
          1400: {
            items: 3,
          },
        }
      case "4":
        return {
          0: {
            items: 1,
          },
          576: {
            items: 2,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
          1200: {
            items: 4,
          },
          1400: {
            items: 5,
          },
        }
      case "6":
        return {
          0: {
            items: 2,
          },
          370: {
            items: 3,
          },
          576: {
            items: 4,
          },
          768: {
            items: 5,
          },
          992: {
            items: 5,
          },
          1200: {
            items: 6,
          },
          1400: {
            items: 7,
          },
        }
      default:
        return {
          0: {
            items: 1,
          },
          340: {
            items: 2,
          },
          576: {
            items: 2,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
          1200: {
            items: 3,
          },
          1400: {
            items: 4,
          },
        }
    }
  }
  getCarouselParams(el) {
    const autoplay = el.dataset.autoplay ? true : false
    const autowidth = el.dataset.autowidth ? true : false
    const nav = el.dataset.hideNav ? false : true
    const loop = autoplay
    return {
      nav,
      navText: [
        '<img src="/local/images/owl_arrow_left.svg" alt="poprzedni" />', 
        '<img src="/local/images/owl_arrow_right.svg" alt="następny" />'
      ],
      loop,
      // stagePadding: el.offsetWidth * .3,
      center: false,
      margin: 30,
      dots: false,
      autoplay,
      slideTransition: "linear",
      autoplayTimeout: 3500,
      autoplayHoverPause: false,
      autoplaySpeed: 3500,
      autowidth,
      responsive: this.getCarouselParamsResponsive(el)
    }
  }
  initCarousel() {
    const el = this.getCarouselElement();
    if (el) {
      const params = this.getCarouselParams(el)
      let $carousel = $(el)
      $carousel.addClass('owl-carousel')
      $carousel.owlCarousel(params)
    }
  }
  destroyCarousel() {
    const el = this.getCarouselElement();
    if (el) {
      let $carousel = $(el)
      $carousel.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded')
      $carousel.find('.owl-stage-outer').children().unwrap()
    }
  }
  getCarouselElement() {
    const container = document.querySelector(this.getContainerSelector())
    return container ? container.querySelector(".item-o-carousel") : false
  }


}

export default OwlCarouselController;